export default __webpack_public_path__ + "static/media/water3.8a00f126.png";